import { LabelError as Error } from './Error';
import { Info } from './Info';
import { Success } from './Success';

export const Label = {
  Error,
  Info,
  Success,
};
